import { authConstants } from './../constants/auth-constants';
import  ConfigurationService  from './../services//configuration-service'

export const agentCommissionList = (data) => async (dispatch) => {
    try {
      const res = await ConfigurationService.getAgentCommissionList();
        dispatch({
        type: authConstants.COMMISSION_LIST,
        payload: res.data,
      });
  
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  };